var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectStoreicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 12,
    fill: "#D3D0FB",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5881 28.7647C26.0428 29.3726 26.623 29.8756 27.2892 30.2396C27.9554 30.6036 28.6921 30.82 29.4493 30.8742C30.2065 30.9285 30.9665 30.8192 31.6778 30.5539C32.3891 30.2886 33.035 29.8734 33.5717 29.3365L36.7481 26.16C37.7125 25.1615 38.2461 23.8242 38.2341 22.4361C38.222 21.048 37.6652 19.7202 36.6836 18.7386C35.7021 17.757 34.3742 17.2003 32.9861 17.1882C31.598 17.1761 30.2607 17.7098 29.2623 18.6741L27.4411 20.4847",
    stroke: "#140B8E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8236 26.6471C29.3689 26.0392 28.7888 25.5362 28.1226 25.1722C27.4564 24.8082 26.7197 24.5918 25.9625 24.5375C25.2052 24.4833 24.4452 24.5926 23.734 24.8579C23.0227 25.1232 22.3768 25.5384 21.8401 26.0753L18.6636 29.2518C17.6992 30.2502 17.1656 31.5876 17.1777 32.9757C17.1898 34.3638 17.7465 35.6916 18.7281 36.6732C19.7097 37.6547 21.0375 38.2115 22.4256 38.2236C23.8137 38.2356 25.151 37.702 26.1495 36.7376L27.9601 34.9271",
    stroke: "#140B8E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectStoreicon);
export default __webpack_public_path__ + "static/media/connectStore.icon.60da7c1f7b32638e4ae6fcd536f84bac.svg";
export { ForwardRef as ReactComponent };